<template>
  <div v-if="show">
    <div id="loader-bg">
      <div id="loader">
        <img src="/static/images/ajax-loader.gif">&nbsp;<span v-text="messages"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      default: '',
      type: String
    },
    show: {
      default: false,
      type: Boolean
    }
  },
}
</script>

<style scope>
  #loader-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: rgba(100, 99, 99, 0.226);
  z-index: 9999;
  }
  #loader {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 250px;
    height: 200px;
    margin-top: -100px;
    margin-left: -100px;
    text-align: center;
    color: rgb(0, 0, 0);
    z-index: 9998;
    font-size: 1.25rem;
  }
</style>